module.exports = __webpack_public_path__ + "img/powerpoint.fd07a4e7.svg";